import React from "react";
import "../startup/Startup.css";
import "../startup/components/AuthOptionsButtons.css";
import { isDevEnvironment } from "env/runtimeEnv";
import { useVisualViewportLayout } from "hooks/useVisualViewportLayout";
import { useJoinWithCodeFlow } from "./useJoinWithCodeFlow";

export default function JoinTeam() {
  const {
    joinCode,
    setJoinCode,
    error,
    setError,
    isValidating,
    isLoading,
    isOnline,
    handleJoin,
  } = useJoinWithCodeFlow();
  const { bottomInset } = useVisualViewportLayout();

  const isBusy = isValidating || isLoading;

  return (
    <form
      className="auth-options-container"
      onSubmit={(e) => {
        e.preventDefault();
        handleJoin();
      }}
    >
      <div className="auth-options-content">
        <div className="auth-options-header">
          <div className="logo-container">
            <div className="logo-wrapper">
              <img
                src="/logo512.png"
                alt="Experience App Icon"
                className="logo-image"
              />
            </div>
          </div>

          {isDevEnvironment && <h1 className="auth-env-label">DEV</h1>}

          <h1 className="welcome-title">Your team</h1>
        </div>

        <div className="auth-email-form-wrapper">
          {error && <div className="auth-error-message">{error}</div>}
          <input
            type="text"
            value={joinCode}
            onChange={(e) => {
              setJoinCode(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter your join code"
            autoComplete="off"
            className="auth-email-input"
          />
        </div>
      </div>

      <div
        className="auth-options-footer"
        style={
          { "--keyboard-inset": `${bottomInset}px` } as React.CSSProperties
        }
      >
        <button
          type="submit"
          disabled={isBusy || !isOnline || !joinCode.trim()}
          className="proceed-button auth-options-submit"
        >
          {!isOnline ? "Offline" : isBusy ? "Checking…" : "Join"}
        </button>
      </div>
    </form>
  );
}
